<template>
	
  <!-- <div>
    <div class="icon">
      <span :class="['icon-status',appliance.online?'green':'gray']" style="font-size: 35px;"/>
    </div>
    <div class="text">
      <span v-if="appliance.online" class="green">{{$t('dashboard.statuses.connected')}}</span> 
      <span v-else class="gray">{{$t('dashboard.statuses.disconnected')}}</span> 
    </div>
  </div> -->
  <!-- <div v-if="flagAlarm">
    <div class="icon">
      <span class="icon-alert red" />
    </div>
    <div class="text">
      <span class="red">{{$t('details.alarm')}}</span> 
    </div>
  </div> -->
  <!--              -->
  <!-- CONSERVATORE -->
  <!--              -->
  <div v-if="appliance.type=='CONSERVATORE'">
    <div class="icon">
      <span v-if="appliance.status && appliance.status.mode!=null" :class="['icon-mode_'+appliance.status.mode]" />
    </div>
    <div class="text">
      <span v-if="appliance.status && appliance.status.mode!=null">{{$t('details.cp.mode_'+appliance.status.mode)}}</span> 
      <span v-else class="gray">{{$t('details.cp.mode_offline')}}</span> 
    </div>
  </div>
  <div v-if="appliance.type=='CONSERVATORE'" :class="[{'gray':!appliance.status || appliance.status.operationalStatus!='cool'}]">
    <div class="icon">
      <span class="icon-air_temp"/>
    </div>
    <div class="text">
      <span v-if="appliance.status && appliance.status.operationalStatus=='cool'">{{$functions.temperature(appliance.status.T1ProbeMeasure, isCelsius)}}{{unit}} - {{$t('details.cp.air_temp_overview')}}</span> 
      <span v-else>-{{unit}} - {{$t('details.cp.air_temp_overview')}}</span> 
    </div>
  </div>
  <!-- <div v-if="appliance.type=='CONSERVATORE' && instantPower">
    <div class="icon" >
      <img src="assets/irinox/icons/energy_green_small.png" style="width: 28px;" :class="[{'filter-gray': !appliance.online}]" alt="Energy"/>
    </div>
    <div class="text">
      <span :class="[{'green': appliance.online}, {'gray': !appliance.online}]">{{ instantPower ? $n(instantPower, 'power') : '-' }} kW - {{ $t("details.instant_power") }}</span> 
    </div>
  </div> -->
  <!--                        -->
  <!-- ABBATTITORE - MF Next  -->
  <!--                        -->
  <div v-if="appliance.type=='ABBATTITORE' && appliance.gamma=='MF Next' && appliance.cycle" :class="[{'gray':!mfCycleRunning}]">
    <div class="icon">
      <i v-if="mfCycleRunning" :class="['cycle-spinner',{'cycle-spinner-spin':mfContinuousCycleRunning}]"><span :class="cycles.icons[appliance.gamma][appliance.cycle.functionRunning].icon" style="font-size: 35px;" /></i>
    </div>
    <div class="text">
      <span v-if="mfCycleRunning">{{appliance.cycle.runningCycleName}}</span> 
      <span v-else>{{$t('mf.no_cycle_running')}}</span>
    </div>
  </div>
  <div v-if="appliance.type=='ABBATTITORE' && appliance.gamma=='MF Next' && !mfIsCore" :class="[{'gray':!mfCycleRunning || !mfAirTemp}]">
    <div class="icon">
      <span class="icon-air_temp"/>
    </div>
    <div class="text">
      <span v-if="mfCycleRunning && mfAirTemp">{{$functions.temperature(mfAirTemp, isCelsius)}}{{unit}} - {{$t('details.mf.air_temp_overview')}}</span> 
      <span v-else>-{{unit}} - {{$t('details.mf.air_temp_overview')}}</span> 
    </div>
  </div>
  <div v-if="appliance.type=='ABBATTITORE' && appliance.gamma=='MF Next' && mfIsCore" :class="[{'gray':!mfCycleRunning || !mfCoreTemp}]">
    <div class="icon">
      <span class="icon-core_temp"/>
    </div>
    <div class="text">
      <span v-if="mfCycleRunning && mfCoreTemp">{{$functions.temperature(mfCoreTemp, isCelsius)}}{{unit}} - {{$t('details.mf.core_temp_overview')}}</span> 
      <span v-else>-{{unit}} - {{$t('details.mf.core_temp_overview')}}</span> 
    </div>
  </div>
  <!-- <div v-if="appliance.type=='ABBATTITORE' && appliance.gamma=='MF Next' && instantPower">
    <div class="icon" >
      <img src="assets/irinox/icons/energy_green_small.png" style="width: 28px;" :class="[{'filter-gray': !appliance.online}]" alt="Energy"/>
    </div>
    <div class="text">
      <span :class="[{'green': appliance.online}, {'gray': !appliance.online}]">{{ instantPower ? $n(instantPower, 'power') : '-' }} kW - {{ $t("details.instant_power") }}</span> 
    </div>
  </div> -->
  <!--                        -->
  <!-- ABBATTITORE - EF Next  -->
  <!--                        -->
  <div v-if="appliance.type=='ABBATTITORE' && appliance.gamma=='EF Next' && appliance.cycle" :class="[{'gray':!efCycleRunning}]">
    <div class="icon">
      <i v-if="efCycleRunning" :class="['cycle-spinner',{'cycle-spinner-spin':efContinuousCycleRunning}]"><span :class="cycles.icons[appliance.gamma][appliance.cycle.functionRunning].icon" style="font-size: 35px;" /></i>
    </div>
    <div class="text">
      <span v-if="efCycleRunning">{{appliance.cycle.runningCycleName}}</span> 
      <span v-else>{{$t('ef.no_cycle_running')}}</span>
    </div>
  </div>
  <div v-if="appliance.type=='ABBATTITORE' && appliance.gamma=='EF Next' && !efIsCore" :class="[{'gray':!efCycleRunning || !efAirTemp}]">
    <div class="icon">
      <span class="icon-air_temp"/>
    </div>
    <div class="text">
      <span v-if="efCycleRunning && efAirTemp">{{$functions.temperature(efAirTemp, isCelsius, 10, 'down')}}{{unit}} - {{$t('details.ef.air_temp_overview')}}</span> 
      <span v-else>-{{unit}} - {{$t('details.ef.air_temp_overview')}}</span> 
    </div>
  </div>
  <div v-if="appliance.type=='ABBATTITORE' && appliance.gamma=='EF Next' && efIsCore" :class="[{'gray':!efCycleRunning || !efCoreTemp}]">
    <div class="icon">
      <span class="icon-core_temp"/>
    </div>
    <div class="text">
      <span v-if="efCycleRunning && efCoreTemp">{{$functions.temperature(efCoreTemp, isCelsius, 10, 'down')}}{{unit}} - {{$t('details.ef.core_temp_overview')}}</span> 
      <span v-else>-{{unit}} - {{$t('details.ef.core_temp_overview')}}</span> 
    </div>
  </div>
  <!--                        -->
  <!-- ABBATTITORE - SF  -->
  <!--                        -->
  <div v-if="appliance.type=='ABBATTITORE' && appliance.gamma=='SF' && appliance.cycle" :class="[{'gray':!efCycleRunning}]">
    <div class="icon">
      <i v-if="efCycleRunning" :class="['cycle-spinner',{'cycle-spinner-spin':efContinuousCycleRunning}]"><span :class="cycles.icons[appliance.gamma][appliance.cycle.functionRunning].icon" style="font-size: 35px;" /></i>
    </div>
    <div class="text">
      <span v-if="efCycleRunning">{{appliance.cycle.runningCycleName}}</span> 
      <span v-else>{{$t('ef.no_cycle_running')}}</span>
    </div>
  </div>
  <div v-if="appliance.type=='ABBATTITORE' && appliance.gamma=='SF' && !efIsCore" :class="[{'gray':!efCycleRunning || !efAirTemp}]">
    <div class="icon">
      <span class="icon-air_temp"/>
    </div>
    <div class="text">
      <span v-if="efCycleRunning && efAirTemp">{{$functions.temperature(efAirTemp, isCelsius, 10, 'down')}}{{unit}} - {{$t('details.ef.air_temp_overview')}}</span> 
      <span v-else>-{{unit}} - {{$t('details.ef.air_temp_overview')}}</span> 
    </div>
  </div>
  <div v-if="appliance.type=='ABBATTITORE' && appliance.gamma=='SF' && efIsCore" :class="[{'gray':!efCycleRunning || !efCoreTemp}]">
    <div class="icon">
      <span class="icon-core_temp"/>
    </div>
    <div class="text">
      <span v-if="efCycleRunning && efCoreTemp">{{$functions.temperature(efCoreTemp, isCelsius, 10, 'down')}}{{unit}} - {{$t('details.ef.core_temp_overview')}}</span> 
      <span v-else>-{{unit}} - {{$t('details.ef.core_temp_overview')}}</span> 
    </div>
  </div>
  <!--                        -->
  <!-- ABBATTITORE - MYA      -->
  <!--                        -->
  <div v-if="appliance.type=='ABBATTITORE' && appliance.gamma=='MYA'" :class="[{'gray':!myaCycleRunning}]">
    <div class="icon">
      <i v-if="myaCycleRunning && myaRunningCycleId!=null" :class="['cycle-spinner']"><span :style="myaIconStyle"/></i>
    </div>
    <div class="text">
      <span v-if="myaCycleRunning && myaRunningCycleId!=null">{{$t('mya.cycles.'+myaRunningCycleId)}}</span> 
      <span v-else>{{$t('mya.no_cycle_running')}}</span>
    </div>
  </div>
  <div v-if="appliance.type=='ABBATTITORE' && appliance.gamma=='MYA'" :class="[{'gray':!myaCycleRunning}]">
    <div class="icon">
      <span class="icon-air_temp"/>
    </div>
    <div class="text">
      <span v-if="myaCycleRunning && myaAirTemp!=null">{{$functions.temperature(myaAirTemp, isCelsius)}}{{unit}} - {{$t('details.mya.air_temp_overview')}}</span> 
      <span v-else>-{{unit}} - {{$t('details.mya.air_temp_overview')}}</span> 
    </div>
  </div>
  <!-- <div v-if="appliance.type=='ABBATTITORE' && appliance.gamma=='MYA' && myaIsCore" :class="[{'gray':!myaCycleRunning || !myaCoreTemp}]">
    <div class="icon">
      <span class="icon-core_temp"/>
    </div>
    <div class="text">
      <span v-if="myaCycleRunning && myaCoreTemp">{{$functions.temperature(myaCoreTemp, isCelsius)}}{{unit}} - {{$t('details.mya.core_temp_overview')}}</span> 
      <span v-else>-{{unit}} - {{$t('details.mya.core_temp_overview')}}</span> 
    </div>
  </div> -->
  <!--              -->
  <!-- FERMALIEVITA - CONSERVATORE -->
  <!--              -->
  <div v-if="appliance.type=='FERMALIEVITA' && deviceTwin.status && deviceTwin.status.function===0">
    <div class="icon">
      <span v-if="appliance.status && appliance.status.mode!=null" :class="['icon-mode_'+(appliance.status.mode-1)]" />
    </div>
    <div class="text">
      <span v-if="appliance.status && appliance.status.mode!=null && appliance.status.mode!==0">{{$t('details.mp.function_0.mode_'+appliance.status.mode)}}</span> 
      <span v-else class="gray">{{$t('details.mp.function_0.mode_0')}}</span> 
    </div>
  </div>
  <div v-if="appliance.type=='FERMALIEVITA'" :class="[{'gray':!appliance.status || ![1,2,3].includes(appliance.status.mode)}]">
    <div class="icon">
      <span class="icon-air_temp"/>
    </div>
    <div class="text">
      <span v-if="appliance.status && [1,2,3].includes(appliance.status.mode)">{{$functions.temperature(appliance.status.TCell, isCelsius)}}{{unit}} - {{$t('details.cp.air_temp_overview')}}</span> 
      <span v-else>-{{unit}} - {{$t('details.cp.air_temp_overview')}}</span> 
    </div>
  </div>
  <div v-if="appliance.type=='FERMALIEVITA' && deviceTwin.status && deviceTwin.status.function===1" :class="[{'gray':!appliance.status || ![1,2,3].includes(appliance.status.mode)}]">
    <div class="icon">
      <span class="icon-humidity"/>
    </div>
    <div class="text">
      <span v-if="appliance.status && [1,2,3].includes(appliance.status.mode)">{{appliance.status.percentHumidity}}% - {{$t('details.mp.function_1.humidity')}}</span> 
      <span v-else>-% - {{$t('details.mp.function_1.humidity')}}</span> 
    </div>
  </div>

</template>

<script>
import cycles from "@/cycles";
import { mapGetters } from 'vuex';
// import EnergyService from '../../service/EnergyService';

export default {
    components: {
    },
    props: {
      serialNumber: String
    },
    data() {
        return {
          cycles: cycles,
          instantPower: null,
          instantPowerInterval: null,
        };
    },
    computed: {
        ...mapGetters({
          personaltoken: 'userdata/personaltoken',
          unit: 'userdata/unit',
          isCelsius: 'userdata/isCelsius',
          deviceTwin: 'appliances/deviceTwin',
        }),
        appliance: function() {
            return this.$store.getters['appliances/appliance'](this.serialNumber);
        },
        flagAlarm: function() {
            if(this.appliance.alarms!=null) {
              for(let i=0; i<this.appliance.alarms.length; i++) {
                if(this.appliance.alarms[i].active) {
                  return true;
                }
              }
            }
            return false;
        },
        mfCycleRunning: function() {
          return this.appliance.online && this.deviceTwin && this.deviceTwin.status && this.deviceTwin.status.cycleRunning && this.deviceTwin.status.cycleRunning === 1;
        },
        mfContinuousCycleRunning: function() {
          //or this !(appliance.cycle.cycleProgressPercentage && appliance.cycle.cycleTimeLeft>0) ?????????
          return this.mfCycleRunning && this.appliance.cycle && this.appliance.cycle.functionRunning && this.appliance.cycle.functionRunning==13;
        },
        mfAirTemp: function() {
          return !this.mfIsCore && this.appliance.status && this.appliance.status.TCell!=null? this.appliance.status.TCell : null;
        },
        mfCoreTemp: function() {
          return this.mfIsCore && this.appliance.status && this.appliance.status.operativeCoreTemperature!=null ? this.appliance.status.operativeCoreTemperature : null;
        },
        mfIsCore: function() {
          return this.appliance.cycle && this.appliance.cycle.coreProbeCheck && this.appliance.cycle.coreProbeCheck==3;
        },
        efCycleRunning: function() {
          return this.appliance.online && this.deviceTwin && this.deviceTwin.status && this.deviceTwin.status.cycleRunning && this.deviceTwin.status.cycleRunning === 1 && this.appliance.cycle && this.appliance.cycle.functionRunning!==0;
        },
        efContinuousCycleRunning: function() {
          //or this !(appliance.cycle.cycleProgressPercentage && appliance.cycle.cycleTimeLeft>0) ?????????
          return this.efCycleRunning && this.appliance.cycle && this.appliance.cycle.functionRunning && this.appliance.cycle.functionRunning==13;
        },
        efAirTemp: function() {
          return !this.efIsCore && this.appliance.status && this.appliance.status.TCell!=null? this.appliance.status.TCell : null;
        },
        efCoreTemp: function() {
          return this.efIsCore && this.appliance.status && this.appliance.status.TCore!=null ? this.appliance.status.TCore : null;
        },
        efIsCore: function() {
          return this.appliance.cycle && this.appliance.cycle.coreProbeCheck && this.appliance.cycle.coreProbeCheck==3;
        },
        myaCycleRunning: function() {
          return this.appliance.online && this.deviceTwin && this.deviceTwin.status && this.deviceTwin.status.cycleRunning && this.deviceTwin.status.cycleRunning === 1;
        },
        myaContinuousCycleRunning: function() {
          return this.mfCycleRunning && this.appliance.cycle && this.appliance.cycle.continuousCycle && this.appliance.cycle.continuousCycle==1;
        },
        myaAirTemp: function() {
          return !this.mfIsCore && this.appliance.status && this.appliance.status.TCell!=null? this.appliance.status.TCell : null;
        },
        // myaCoreTemp: function() {
        //   return this.mfIsCore && this.appliance.status && this.appliance.status.operativeCoreTemperature ? this.appliance.status.operativeCoreTemperature : null;
        // },
        // myaIsCore: function() {
        //   return this.appliance.cycle && this.appliance.cycle.coreProbeCheck && this.appliance.cycle.coreProbeCheck==3;
        // },
        myaRunningCycleId: function() {
          return this.appliance.cycle && this.appliance.cycle.runningCycleId!=null ? this.appliance.cycle.runningCycleId.replace(/.*_/g, '') : null;
        },
        myaIconStyle() {
          let myaCycles = this.cycles.icons[this.appliance.gamma];
          let myaCycle = myaCycles[this.myaRunningCycleId];
          if(myaCycle!=null) {
            return 'background-color: #002445; '+
              'mask: url(\'assets/irinox/icons'+myaCycle.svg+'\') no-repeat 50% 50%; '+
              '-webkit-mask: url(\'assets/irinox/icons'+myaCycle.svg+'\') no-repeat 50% 50%; '+
              'margin: 0;';
          }
          return '';
        }
    },
  created() {
    // this.energyService = new EnergyService();
  }, mounted() {
    // if (
    //   this.appliance.online &&
    //   (this.appliance.type === 'CONSERVATORE' ||
    //     (this.appliance.type === 'ABBATTITORE' && this.appliance.gamma === 'MF Next'))
    // ) {
    //   this.getInstantPower();
    //   this.instantPowerInterval = setInterval(() => {
    //     console.log("interval")
    //     if (this.appliance.online) {
    //       this.getInstantPower();
    //     }
    //   }, 20000);
    // }
  },
  beforeUnmount() {
    // if (this.instantPowerInterval) {
    //   clearInterval(this.instantPowerInterval);
    // }
  },
  methods: {
    // getInstantPower() {
    //   this.energyService.getInstantPower(this.personaltoken, this.serialNumber)
    //     .then((data) => {
    //       // console.log("ENERGY " + data);
    //       if(data.code == "200") {
    //         this.instantPower = data.body;
    //       } else {
    //         console.error("ERROR " + JSON.stringify(data));
    //         this.instantPower = null;
    //       }
    //     })
    //     .catch(error => {
    //       console.error("ERROR " + error);
    //       this.instantPower = null;
    //     });
    // }
  },
}
</script>

<style >

</style>